module.exports = __webpack_public_path__ + "img/08.70546649.jpg";